import { render } from "./reportQuestion.vue?vue&type=template&id=0f966fd2&ts=true"
import script from "./reportQuestion.vue?vue&type=script&lang=ts"
export * from "./reportQuestion.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__